export default {
    mapLandmarkBulk_title: "Acciones masivas para puntos de Referencia",
    mapLandmarkBulk_iconType: "Icon Type",
    mapLandmarkBulk_custom: "A Medida",
    mapLandmarkBulk_Icon_color: "Icon & Color",
    mapLandmarkBulk_landmark: "Puntos de referencia actualizados",
    mapLandmarkBulk_landmark_selected: "Puntos de referencia seleccionados",
    mapLandmarkBulk_selectedLandmarks: "Los puntos de referencia seleccionados pertenecen a los siguientes grupos",
    mapLandmarkBulk_tag: "Etiqueta",
};